import { render } from "./VPAAReportsDialog.vue?vue&type=template&id=f9044ad0"
import script from "./VPAAReportsDialog.vue?vue&type=script&lang=js"
export * from "./VPAAReportsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__